import axios from "axios";

// Ici on force l'API MonAppliClub pour les abonnements/parrainages
// car ton site Shiatsu peut avoir un REACT_APP_API_URL différent.
const MONAPPLICLUB_API_URL =
  process.env.REACT_APP_MONAPPLICLUB_API_URL || "https://api.monappliclub.com";

const getAuthHeaders = () => {
  const token =
    localStorage.getItem("token") ||
    localStorage.getItem("authToken") ||
    localStorage.getItem("userToken");

  return token
    ? {
        Authorization: `Bearer ${token}`,
      }
    : {};
};

export const getSubscriptionsByAssociation = async (assoId) => {
  if (!assoId) {
    throw new Error("assoId manquant pour récupérer les abonnements");
  }

  const url = `${MONAPPLICLUB_API_URL}/api/subscriptions/subscriptionsByAssociation/${assoId}`;

  console.log("URL abonnements appelée :", url);

  const res = await axios.get(url, {
    headers: getAuthHeaders(),
  });

  return Array.isArray(res.data) ? res.data : [];
};

export const addParrainage = async (payload) => {
  const url = `${MONAPPLICLUB_API_URL}/api/parrainage/addParrainage`;

  const res = await axios.post(url, payload, {
    headers: getAuthHeaders(),
  });

  return res.data;
};